// Libellés partagés par tout ce qui affiche ou saisit un insight.
import type { Cost, HypothesisOutcome, HypothesisStatus, Impact, ObjectiveImportance, ProblemType, RecoKind } from '../api/types';

/** Nature d'une recommandation : à qui elle s'adresse dans l'équipe. */
export const RECO_KINDS: { value: RecoKind; label: string }[] = [
  { value: 'interface', label: 'Interface' },
  { value: 'fonctionnalite', label: 'Fonctionnalité' },
  { value: 'processus', label: 'Processus' },
  { value: 'contenu', label: 'Contenu' },
  { value: 'ia_data', label: 'IA / Data' },
  { value: 'autre', label: 'Autre' },
];

export const RECO_KIND_LABEL = Object.fromEntries(RECO_KINDS.map((k) => [k.value, k.label])) as Record<RecoKind, string>;

/** Nature du problème (migration 045) : ce qui gêne, ce qui manque, ce qu'on bricole. */
export const PROBLEM_TYPES: { value: ProblemType; label: string; hint: string }[] = [
  { value: 'irritant', label: 'Irritant', hint: 'Quelque chose gêne les utilisateurs.' },
  { value: 'besoin', label: 'Besoin', hint: 'Quelque chose leur manque.' },
  { value: 'contournement', label: 'Contournement', hint: 'Ils bricolent une solution faute de mieux.' },
];
export const PROBLEM_TYPE_LABEL = Object.fromEntries(PROBLEM_TYPES.map((k) => [k.value, k.label])) as Record<ProblemType, string>;

/** Où en est une hypothèse (migration 051). */
export const HYPOTHESIS_STATUS_LABEL: Record<HypothesisStatus, string> = {
  a_tester: 'À tester',
  en_test: 'En test',
  confirmee: 'Confirmée',
  infirmee: 'Infirmée',
  abandonnee: 'Abandonnée',
};

/** Ce que dit l'avant/après. */
export const OUTCOME_LABEL: Record<HypothesisOutcome['level'], string> = {
  atteinte: 'Cible atteinte',
  en_progres: 'En progrès',
  sans_effet: 'Sans effet',
  recul: 'En recul',
};

/** Importance d'un objectif du projet (migration 049) et son coefficient dans la priorité. */
export const IMPORTANCES: { value: ObjectiveImportance; label: string; factor: string }[] = [
  { value: 'principal', label: 'Principal', factor: '× 1,5' },
  { value: 'secondaire', label: 'Secondaire', factor: '× 1,2' },
];

/** Ce que gagnerait le métier à traiter le problème. */
export const IMPACTS: { value: Impact; label: string }[] = [
  { value: 'faible', label: 'Faible' },
  { value: 'moyen', label: 'Moyen' },
  { value: 'fort', label: 'Fort' },
];

/** Ce que coûterait sa résolution. */
export const COSTS: { value: Cost; label: string }[] = [
  { value: 'petit', label: 'Petit' },
  { value: 'moyen', label: 'Moyen' },
  { value: 'gros', label: 'Gros' },
];

export const PRIORITY_LABEL = { haute: 'Priorité haute', moyenne: 'Priorité moyenne', basse: 'Priorité basse' } as const;
export const FREQUENCY_LABEL = { faible: 'faible', moyenne: 'moyenne', elevee: 'élevée' } as const;
